import React from 'react';
import {NumberInput} from '@mantine/core';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import type {ActionEditorProps} from './ActionCard';

export const ActionExtendBadgeEditor: React.FC<ActionEditorProps> = ({
  action,
  onActionChange,
}) => {
  const days = action.metadata?.extendBadgeExpirationMetadata?.days ?? 1;

  const handleDaysChange = (value: string | number) => {
    onActionChange({
      ...action,
      metadata: {
        ...action.metadata,
        extendBadgeExpirationMetadata: {
          days: Number(value) || 0,
        },
      },
    });
  };

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        Extend the badge expiration date for the contractor who triggered this
        workflow. If the current expiration is in the future, days are added from
        that date. If expired or not set, days are added from today.
      </Text>
      <NumberInput
        label="Days to Extend"
        description="Number of days to extend the badge expiration by."
        value={days}
        onChange={handleDaysChange}
        min={1}
        max={3650}
        required
      />
    </Stack>
  );
};
